import {
  MemberDto,
  MemberMetaDto,
  SetEmailRequestDto,
  SetPhoneNumberRequestDto,
  UpdateMemberProfileDto,
  VerificationResponseDto,
} from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';

const REQUEST_SAVE_PROFILE = '[Profile][Request] Save profile';
const RESPONSE_SUCCESS_SAVE_PROFILE = '[Profile][Response][Success] Save profile';
const RESPONSE_FAIL_SAVE_PROFILE = '[Profile][Response][Fail] Save profile';

export const REQUEST_UPDATED_PROFILE = '[Profile][Request] Updated profile';
export const RESPONSE_SUCCESS_UPDATED_PROFILE = '[Profile][Response][Success] Updated profile';
export const RESPONSE_FAIL_UPDATED_PROFILE = '[Profile][Response][Fail] Updated profile';

export const CLEAR_VERIFICATION = '[Profile][Request] Clear current verification';
export const REQUEST_VERIFICATION = '[Profile][Request] Verification';
export const RESPONSE_SUCCESS_VERIFICATION = '[Profile][Response][Success] Verification';
export const RESPONSE_FAIL_VERIFICATION = '[Profile][Response][Fail] Verification';

export const REQUEST_SET_PHONE_NUMBER = '[Profile][Request] Set phone number';
export const RESPONSE_SUCCESS_SET_PHONE_NUMBER = '[Profile][Response][Success] Set phone number';
export const RESPONSE_FAIL_SET_PHONE_NUMBER = '[Profile][Response][Fail] Set phone number';

export const REQUEST_SET_EMAIL_ADDRESS = '[Profile][Request] Set email address';
export const RESPONSE_SUCCESS_SET_EMAIL_ADDRESS = '[Profile][Response][Success] Set email address';
export const RESPONSE_FAIL_SET_EMAIL_ADDRESS = '[Profile][Response][Fail] Set email address';

export const REQUEST_UPDATE_MEMBER_META = '[Auth][Request] Update Member Meta';
export const RESPONSE_SUCCESS_UPDATE_MEMBER_META = '[Auth][Response][Success] Update Member Meta';
export const RESPONSE_FAIL_UPDATE_MEMBER_META = '[Auth][Response][Fail] Update Member Meta';

export class ClearVerificationAction {
  readonly type = CLEAR_VERIFICATION;
  constructor() {}
}

export class RequestVerificationAction {
  readonly type = REQUEST_VERIFICATION;
  constructor(public channel: 'sms' | 'email', public to: string) {}
}

export class ResponseSuccessVerificationAction {
  readonly type = RESPONSE_SUCCESS_VERIFICATION;
  constructor(public payload: VerificationResponseDto) {}
}

export class ResponseFailVerificationAction {
  readonly type = RESPONSE_FAIL_VERIFICATION;
  constructor(public payload: string) {}
}

export class RequestSetPhoneNumberAction {
  readonly type = REQUEST_SET_PHONE_NUMBER;
  constructor(public payload: SetPhoneNumberRequestDto) {}
}

export class ResponseSuccessSetPhoneNumberAction {
  readonly type = RESPONSE_SUCCESS_SET_PHONE_NUMBER;
  constructor(public payload: MemberDto) {}
}

export class ResponseFailSetPhoneNumberAction {
  readonly type = RESPONSE_FAIL_SET_PHONE_NUMBER;
  constructor(public payload: string) {}
}

export class RequestSetEmailAddressAction {
  readonly type = REQUEST_SET_EMAIL_ADDRESS;
  constructor(public payload: SetEmailRequestDto) {}
}

export class ResponseSuccessSetEmailAddressAction {
  readonly type = RESPONSE_SUCCESS_SET_EMAIL_ADDRESS;
  constructor(public payload: MemberDto) {}
}

export class ResponseFailSetEmailAddressAction {
  readonly type = RESPONSE_FAIL_SET_EMAIL_ADDRESS;
  constructor(public payload: string) {}
}

export const RequestSaveProfile = createAction(
  REQUEST_SAVE_PROFILE,
  props<{ payload: UpdateMemberProfileDto }>()
);

export const ResponseFailSaveProfile = createAction(
  RESPONSE_FAIL_SAVE_PROFILE,
  props<{ error: any }>()
);

export const ResponseSuccessSaveProfile = createAction(
  RESPONSE_SUCCESS_SAVE_PROFILE,
  props<{ payload: MemberDto }>()
);

export class RequestUpdatedProfileAction {
  readonly type = REQUEST_UPDATED_PROFILE;
}

export class ResponseSuccessUpdatedProfileAction {
  readonly type = RESPONSE_SUCCESS_UPDATED_PROFILE;
  constructor(public payload: MemberDto) {}
}

export class ResponseFailUpdatedProfileAction {
  readonly type = RESPONSE_FAIL_UPDATED_PROFILE;
  constructor(public error: string) {}
}

export const RequestUpdateMemberMetaAction = createAction(
  REQUEST_UPDATE_MEMBER_META,
  props<{ payload: Partial<MemberMetaDto> }>()
);

export const ResponseSuccessUpdateMemberMetaAction = createAction(
  RESPONSE_SUCCESS_UPDATE_MEMBER_META,
  props<{ payload: MemberMetaDto }>()
);

export const ResponseFailUpdateMemberMetaAction = createAction(
  RESPONSE_FAIL_UPDATE_MEMBER_META,
  props<{ payload: any }>()
);
